import { FC } from 'react'
import { PageProps } from './Page1'
import Letterhead from './Letterhead'

const Page5: FC<PageProps> = ({ data }) => {
  return (
    <Letterhead data={data} pageNumber={5}>
      <p className="text">
        ۱۱-۸ پذیرنده متعهد می‌شود قوانین و مقررات خود در خصوص مرجوعی کالا و
        خدمات را بدون هیچ تغییری برای سفارش‌هایی که از طریق سرویس اعتباری آپولون
        ثبت می‌شوند نیز اعمال نماید. در صورت مرجوعی کالا یا خدمات خریداری شده
        توسط کاربر به صورت کلی یا جزئی، طرفین متعهد به انجام موارد زیر هستند:
      </p>
      <p className="text">
        - پذیرنده موظف است مراتب را ظرف حداکثر ۲۴ ساعت پس از مرجوعی کالا به‌صورت
        سیستمی به آپولون اعلام کند.
      </p>
      <p className="text">
        - کلیه مسئولیت‌های مربوط به لجستیک کالا (در صورت نیاز) و خدمات مرجوعی
        برعهده پذیرنده است.
      </p>
      <p className="text">
        - آپولون موظف است هزینه پرداخت شده توسط کاربر را متناسب با مبلغ کالا و
        خدمات مرجوع شده به کاربر عودت دهد.
      </p>
      <p className="text">
        - در صورتیکه مبلغ کالای مرجوعی با پذیرنده تسویه شده باشد، آپولون در
        اولین سیکل تسویه بعدی، مبلغ کالای مرجوعی را از حساب پذیرنده کسر می‌کند.
      </p>
      <p className="text">
        ۱۲-۸ پذیرنده متعهد می شود که استفاده از نام و برند تجاری آپولون به هر
        شکل و نوع در هرگونه تبلیغات و فعالیت‌های بازاریابی و برندینگ، با اجازه و
        هماهنگی شرکت آپولون انجام شود
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۹)</p>
      <p className="mb-2 text-lg font-bold">حوادث غیرمترقبه (فورس ماژور)</p>
      <p className="text">
        در صورت بروز هرگونه سوانح طبیعی و یا غیرطبیعی خارج از قدرت و اراده طرفین
        اعم از سیل، زلزله، بیماری واگیردار، جنگ و وضع قوانین مؤثر بر آن و غیره،
        به‌نوعی که طرفین مجبور به توقف اجرای آن تا زمان رفع فورس ماژور باشند،
        مدت مذکور جزو مدت قرارداد محسوب نمی شود.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۱۰)</p>
      <p className="mb-2 text-lg font-bold">محرمانه بودن اطلاعات</p>
      <p className="text">
        کلیه اطلاعات، اسناد، مدارک و تعاملاتی که برای اجرای این قرارداد در اختیار
        طرفین قرارداد و یا کارکنان آنان قرار می‌گیرد (اعم از کتبی یا شفاهی) و یا
        به نحوی به آن دسترسی می‌یابند اعم از اینکه در رابطه با اجرای موضوع
        قرارداد باشد یا نباشد، محرمانه تلقی شده و طرفین موظف به محرمانه
        نگاه‌داشتن آن‌ها می باشند و تمام حسن نیت خود را بدین منظور به کار می
        گیرند و موافقت می‌نمایند که از این اطلاعات تنها در راستای اجرای مفاد این
        قرارداد استفاده خواهند کرد
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۱۱)</p>
      <p className="mb-2 text-lg font-bold">حل و فصل اختلافات</p>
      <p className="text">
        در صورت بروز هر گونه اختلاف فی مابین طرفین قرارداد به دلیل تعبیر و یا
        تفسیر بخشی و یا کل قرارداد، طرفین با حسن نیت سعی به حل مسالمت آمیز اختلاف
        از طریق مذاکره نموده و در صورت عدم حصول نتیجه از طریق مراجع قضائی تهران
        نسبت به حل اختلاف خود اقدام می‌نمایند.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۱۲)</p>
      <p className="mb-2 text-lg font-bold">انتقال قرارداد</p>
      <p className="text">
        مباشرت طرفین قرارداد در انجام موضوع آن، به عنوان جزء لاینفک قرارداد شرط
        گردید و طرفین حق واگذاری موضوع قرارداد را به صورت کلی و جزئی از تمامی
        طرق قانونی اعم از وکالت، صلح و غیره به اشخاص حقیقی و یا حقوقی دیگر را
        ندارند و در صورت تخلف، طرف دیگر مجاز به فسخ قرارداد و دریافت ضرر و زیان
        حاصل از تخلف طرف خاطی می‌باشد.
      </p>
    </Letterhead>
  )
}

export default Page5
